// CTSK-525 — which inline preview branch a document gets.
export type PreviewKind = 'image' | 'markdown' | 'pdf' | 'html' | 'text' | 'fallback';

export function previewKindFor(mime: string | null | undefined, title = ''): PreviewKind {
  const m = (mime ?? '').toLowerCase().split(';')[0]?.trim() ?? '';
  const t = title.toLowerCase();
  if (m.startsWith('image/') && m !== 'image/svg+xml') return 'image';
  if (m === 'application/pdf') return 'pdf';
  if (m === 'text/markdown' || m === 'text/x-markdown' || (m.startsWith('text/') && /\.(md|markdown)$/.test(t))) return 'markdown';
  if (m === 'text/html' || m === 'application/xhtml+xml') return 'html';
  if (m === 'text/plain') return 'text';
  return 'fallback';
}
